import axios from "axios";
const JSONbig = require('json-bigint')({ 'storeAsString': true })

//pass new generated access token here
// const token = `Bearer ${localStorage.getItem("accessToken")}`;
// const ClientId = localStorage.getItem("ClientId");

export const BASE_URL = process.env.REACT_APP_PF_MERCHANT_GATEWAY_API_URL;

export const axiosApi = axios.create({
  baseURL: BASE_URL,
  transformResponse: [data => data]
});


axiosApi.interceptors.response.use((response) => {
  try {
    if (response.data == null || response.data === "") {
      return response.data;
    }
    if (typeof response.data === "object") {
      return response.data;
    }
    return JSONbig.parse(response.data);
  } catch (parseError) {
    return Promise.reject(parseError);
  }
}, (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem("authUser");
  }
  return Promise.reject(error);
});

// axiosApi.interceptors.request.use(
//   (config) => {
//     let token = localStorage.getItem("accessToken");
//     config.headers.Authorization = "Bearer " + token;;
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

axiosApi.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("Act");
    config.headers.Authorization = token;;
    return config;
  },
  (error) => Promise.reject(error)
);

export async function get(url, data, config = {}) {
  return await axiosApi.get(url, data, { transformResponse: [data => data] });
}

export async function post(url, data, config = {}) {
  return await axiosApi.post(url, data, { transformResponse: [data => data] })
}

export async function put(url, data, config = {}) {
  return await axiosApi.put(url, data, { transformResponse: [data => data] })
}

export async function del(url, data, config = {}) {
  return await axiosApi.delete(url, data, { transformResponse: data => data })
}
export async function postForm(url, data, config = {}) {
  return await axiosApi.postForm(url, data, { transformResponse: [data => data] })
}
export async function postFormV2(url, data, config = {}) {
  return await axiosApi.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }, { transformResponse: [data => data] })
}
